import React, { useRef } from "react";
import { Chip, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useClasses = makeStyles(theme => ({
  statusPositive: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white
  },
  statusNegative: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white
  },
  statusCanceled: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white
  },
  statusWithLab: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white
  }
}));

const TestStatusChip = ({ patient }) => {
  const { t } = useTranslation();
  const classes = useClasses();
  let status = useRef({
    label: t("components.test_status_chip.pending"),
    class: "statusPending"
  });

  if (patient.test_result === "pos") {
    status.current = {
      label: t("components.test_status_chip.positive"),
      class: "statusPositive"
    };
  } else if (patient.test_result === "neg") {
    status.current = {
      label: t("components.test_status_chip.negative"),
      class: "statusNegative"
    };
  } else if (patient.test_status === "with_lab") {
    status.current = {
      label: t("components.test_status_chip.with_lab"),
      class: "statusWithLab"
    };
  } else if (patient.test_status === "cancelled") {
    status.current = {
      label: t("components.test_status_chip.canceled"),
      class: "statusCanceled"
    };
  }

  return (
    <Chip
      label={status.current.label}
      size="small"
      className={classes[status.current.class]}
    />
  );
};

export { TestStatusChip };
